import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faHouse,
  faScrewdriverWrench,
  faClipboardList,
  faCircleCheck,
} from '@fortawesome/free-solid-svg-icons';
import { CUSTOMER_PORTAL_ROUTES } from '@/routes/customer-portal-routes';

const ITEMS = [
  { to: CUSTOMER_PORTAL_ROUTES.DASHBOARD, label: 'Home', icon: faHouse, end: true },
  { to: CUSTOMER_PORTAL_ROUTES.EQUIPMENT, label: 'Equipment', icon: faScrewdriverWrench },
  { to: CUSTOMER_PORTAL_ROUTES.JOBS, label: 'Jobs', icon: faClipboardList },
  // D-130 Phase 6R — the decision queue is the portal's primary ACTION
  // surface, and until now it was reachable only from a dashboard link.
  // On a phone that meant a customer who navigated away could not get
  // back to the jobs waiting on them without returning to Home first.
  { to: CUSTOMER_PORTAL_ROUTES.DECISIONS, label: 'Decisions', icon: faCircleCheck },
];

/**
 * Phone/tablet bottom tab bar (hidden from `lg`, where the fixed sidebar is
 * the navigation). Thumb-reachable, 44px+ targets, active
 * state by colour AND weight. The drawer stays available from the header for
 * branding and sign-out; this bar is the everyday navigation.
 *
 * Four destinations since 6R. At 320px that is 80px per tab — still well
 * clear of the 44px minimum, and the label stays on one line.
 */
export function CustomerMobileNav() {
  return (
    <nav
      aria-label="Primary"
      className="customer-safe-bottom fixed inset-x-0 bottom-0 z-30 border-t border-customer-border bg-customer-surface/95 backdrop-blur supports-[backdrop-filter]:bg-customer-surface/90 lg:hidden"
    >
      <ul className="mx-auto flex h-customer-nav max-w-md items-stretch">
        {ITEMS.map((item) => (
          <li key={item.to} className="flex-1">
            <NavLink
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                [
                  'customer-pressable flex h-full flex-col items-center justify-center gap-1 text-[11px] font-medium leading-none transition-colors',
                  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-customer-ring',
                  isActive
                    ? 'text-customer-primary-text'
                    : 'text-customer-text-secondary hover:text-customer-text',
                ].join(' ')
              }
            >
              {({ isActive }) => (
                <>
                  <span
                    className={[
                      'flex h-7 w-12 items-center justify-center rounded-full transition-colors',
                      isActive ? 'bg-customer-primary/10' : '',
                    ].join(' ')}
                    aria-hidden="true"
                  >
                    <FontAwesomeIcon icon={item.icon} className="h-4 w-4" />
                  </span>
                  <span className={isActive ? 'font-semibold' : ''}>{item.label}</span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
